import React, { FunctionComponent } from 'react';
import { Redirect } from 'react-router-dom';
import GetPathFromAdminScreen from '../../Methods/GetPathFromAdminScreen';

interface Props {}

const HomeRedirect: FunctionComponent<Props> = () => {
  const lastScreen = localStorage.getItem('last-screen');
  const redirectPath: string = GetPathFromAdminScreen(lastScreen);
  return <Redirect to={redirectPath} />;
};

export default HomeRedirect;
